import PageHeaderRoot from './PageHeaderRoot';
import PageMedia from './PageMedia';
import PageSummary from './PageSummary';

const PageHeaderOverview = () => {
  return (
    <PageHeaderRoot
      variant="overview"
      paper
      afterCol={<PageSummary variant="h4" />}
      afterContainer={<PageMedia />}
    />
  );
};

export default PageHeaderOverview;
